import { DataCell } from 'shared';
import { Currency } from 'types/general.types';
import { TransactionType } from 'types/util.types';
import { formatCurrency } from 'utils/formatters';

import styles from './CurrencyCell.module.scss';

type CurrencyCellProps = { currency?: Currency; amount?: number; type?: TransactionType };

const CurrencyCell = ({ currency, type, amount }: CurrencyCellProps) => {
  const isNeutral = amount === 0;
  let isPositive = false;

  if (type === TransactionType.ELECTRICITY_COSTS || type === TransactionType.BTC_PAYOUTS) {
    isPositive = false;
  } else if (type === TransactionType.BTC_EARNINGS || type === TransactionType.TOP_UP) {
    isPositive = true;
  } else if (!isNeutral) {
    isPositive = (amount ?? 0) > 0;
  }

  let prefix = '';
  if (!isNeutral) {
    prefix = isPositive ? '+ ' : '- ';
  }

  let className = '';
  if (!isNeutral) {
    className = isPositive ? styles.positive : styles.negative;
  }

  return (
    <DataCell className={className}>
      {prefix}
      {amount && currency ? formatCurrency(currency, Math.abs(amount)) : '—'}
    </DataCell>
  );
};

export default CurrencyCell;
